<div *ngIf="spinnerFlag" class="spinner-container">
    <app-spinner class="spinner-addcomment">
    </app-spinner>
    </div>